module.exports = __webpack_public_path__ + "img/i-roles-5.a954ac4b.png";